import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon, CheckIcon, LockIcon } from "lucide-react";
import { book, heroPoints } from "../data/book";
import { BookCover } from "./BookCover";
export function Hero() {
  return <section id="top" className="relative overflow-hidden bg-ink" data-id="element-63" data-mp="9ll6ipqopkjt">
      <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-6 pt-16 pb-20 lg:grid-cols-[1.15fr_1fr] lg:px-10 lg:pt-24 lg:pb-28" data-id="element-64" data-mp="4m8kg77n0hia">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-65" data-mp="128pgl94mwp2g">
          <p className="font-serif text-sm tracking-[0.3em] text-gold sm:text-base" data-id="element-66" data-mp="sde0onhhpbt4">
            A BOOK FOR FOUNDERS
          </p>
          <h1 className="mt-4 font-display text-6xl leading-[0.95] text-cream sm:text-7xl xl:text-8xl" data-id="element-67" data-mp="3d1aafpn8alfx">
            The
            <br data-id="element-68" data-mp="3825w6klg5xiq" />
            Mentored
            <br data-id="element-69" data-mp="3814e3w60kari" />
            Founder
          </h1>

          <div aria-hidden="true" className="mt-8 flex items-center gap-3" data-id="element-70" data-mp="3j895n7fl21mw">
            <span className="h-px w-36 bg-gold/50" data-id="element-71" data-mp="3o7c1c19oavi7" />
            <span className="h-[2px] w-12 bg-gold" data-id="element-72" data-mp="3o73og9djvq70" />
          </div>

          <p className="mt-7 max-w-md font-serif text-2xl leading-snug text-cream/90" data-id="element-73" data-mp="39b4fyxmj3o1c">
            {book.subtitle}.
          </p>

          <ul className="mt-7 space-y-3" data-id="element-74" data-mp="3e7ux7oa2kpoc">
            {heroPoints.map(point => <li key={point} className="flex items-center gap-3 text-cream/85" data-id="element-75" data-mp="30hreh7aefe3n">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-76" data-mp="358howyxom757">
                  <CheckIcon className="h-3 w-3 text-ink" strokeWidth={3} data-id="element-77" data-mp="2qkdaw89kqjsr" />
                </span>
                {point}
              </li>)}
          </ul>

          <div className="mt-10 max-w-md" data-id="element-78" data-mp="2vgu0l6wf967y">
            <a href={book.preorderUrl} target="_blank" rel="noopener noreferrer" className="group flex w-full items-center justify-center gap-3 rounded-lg bg-gold px-8 py-5 text-lg font-bold uppercase tracking-wider text-ink transition-colors duration-150 ease-out hover:bg-gold-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-79" data-mp="2hincujl6smm0">
              Pre-order now
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-80" data-mp="ichy92uaue3j" />
            </a>
            <p className="mt-4 flex items-center justify-center gap-2 text-sm text-muted" data-id="element-81" data-mp="1b0w05toidukd">
              <LockIcon className="h-3.5 w-3.5" data-id="element-82" data-mp="161t3awiomunh" />
              Secure checkout. Ships worldwide. Out {book.releaseDate}.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto w-full max-w-[300px] sm:max-w-[360px] lg:max-w-[420px]" data-id="element-83" data-mp="110wpnr8j3u4v">
          <BookCover data-id="element-84" data-mp="3htq03xma4up3" />
        </motion.div>
      </div>
    </section>;
}